import { useQuery } from "@tanstack/react-query";
import newApi from "src/newApi";

import options from "./defaultOptions";

export function useGetUserStats(query) {
	return useQuery({
		queryKey: ["user-stats", query],

		queryFn: async () => {
			return newApi.getStatistics(query);
		},

		...options,
	});
}
